import { stats } from "@/mocks/data";

export default function StatsSection() {
  return (
    <section className="py-12 md:py-16 bg-primary-500">
      <div className="container-page">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, idx) => (
            <div key={idx} className="text-center">
              <div className="text-3xl md:text-4xl font-heading font-bold text-background-50 mb-2">
                {stat.value}
              </div>
              <div className="text-sm text-primary-100">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}